export const SET_VISIBILITY_VIDEO = "SET_VISIBILITY_VIDEO"

export const setVisibilityVideo = () => dispatch => {
    dispatch(
        {
            type: SET_VISIBILITY_VIDEO
        }
    )
}
